var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 701,
    height: 599,
    viewBox: "0 0 701 599",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6101 427.148H442.61C462.21 427.148 478.21 409.948 478.21 388.948C478.21 367.948 462.21 350.748 442.61 350.748H36.6101C16.9101 350.748 0.910146 367.948 0.910146 388.948C0.910146 409.948 16.9101 427.148 36.6101 427.148ZM36.6101 248.948H442.61C462.21 248.948 478.21 231.848 478.21 210.748C478.21 189.748 462.21 172.548 442.61 172.548H36.6101C16.9101 172.548 0.910146 189.748 0.910146 210.748C0.910146 231.748 16.9101 248.948 36.6101 248.948ZM39.1101 77.1482H660.81C681.81 77.1482 700.31 61.2482 700.91 40.3482C701.61 19.2482 685.11 1.64824 664.01 0.948242C663.61 0.948242 663.21 0.948242 662.71 0.948242H41.0101C20.0101 0.948242 1.51015 16.8482 0.910146 37.8482C0.210146 58.9482 16.7101 76.6482 37.8101 77.3482C38.2101 77.1482 38.7101 77.2482 39.1101 77.1482ZM523.31 426.548V173.248L700.91 299.848L523.31 426.548C523.31 427.148 523.31 427.148 523.31 426.548ZM662.71 522.648H41.0101C20.0101 522.648 1.51015 538.648 0.910146 559.548C0.210146 580.648 16.7101 598.248 37.8101 598.948C38.2101 598.948 38.6101 598.948 39.1101 598.948H660.81C681.81 598.948 700.31 582.948 700.91 562.048C701.61 540.948 685.11 523.348 664.01 522.648C663.51 522.648 663.11 522.548 662.71 522.648Z",
    fill: "url(#paint0_linear_684_10)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_684_10",
    x1: 10.4649,
    y1: 14.2307,
    x2: 691.35,
    y2: 585.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.229788,
    stopColor: "#03AE86",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532554,
    stopColor: "#10A589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762657,
    stopColor: "#07463D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#031B1B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.250a8d3cba56d1b12563c81a09202e69.svg";
export { ForwardRef as ReactComponent };